import { render, staticRenderFns } from "./_live-create.vue?vue&type=template&id=cd40820c&scoped=true"
import script from "./_live-create.vue?vue&type=script&lang=js"
export * from "./_live-create.vue?vue&type=script&lang=js"
import style0 from "./_live-create.vue?vue&type=style&index=0&id=cd40820c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40820c",
  null
  
)

export default component.exports